import { matchPath } from 'react-router-dom'

/**
 * Makes a feature route pattern relative to Core's concrete matched parent path.
 * Parameter segments match concrete values before consumed segments are removed.
 * Returns null for unrelated paths, or an empty string for a fully consumed route
 * that should render as an index route and inherit Core's route parameters.
 */
export const relativeFeaturePath = (pattern: string, parentPath: string): string | null => {
  const segments = pattern.split('/').filter(Boolean)
  const parentSegments = parentPath.split('/').filter(Boolean)

  if (parentSegments.length > segments.length) return null

  const consumedPattern = '/' + segments.slice(0, parentSegments.length).join('/')

  if (!matchPath({ path: consumedPattern, end: true }, parentPath || '/')) {
    return null
  }

  return segments.slice(parentSegments.length).join('/')
}
